const RecommendedBadge = () => (
  <span className="w-fit rounded bg-[#116A43] px-1 py-0.5 text-xxs font-bold text-white">
    Recommended
  </span>
);

export default RecommendedBadge;
